import { SiteUrl } from '@wix/ambassador-events-v1-event/types';

export function getEventPage(eventPageUrl: SiteUrl | undefined) {
  return eventPageUrl ? `${eventPageUrl.base}${eventPageUrl.path}` : undefined;
}
